<template>
  <router-view
    v-if="currentCampaign"
    :key="currentCampaign?.id"
    :campaign="currentCampaign"
    :site="site"
    :hasUnlimitedAccess="hasUnlimitedAccess"
    :isWhiteGloveUser="isWhiteGloveUser"
    :isMissionControlSession="isMissionControlSession"
    :reloadUser="reloadUser"
  ></router-view>
</template>

<script>
export default {
  props: ['campaignId', 'currentCampaign', 'site', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession'],
  components: {
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    reloadUser() {
      // reload user to update ui with any credit usage
      this.$store.dispatch("loadUser").then(response => {
        this.$store.commit("setUser", response.data.user);
      });
    },
  },
  mounted () {
    
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>